import { render, staticRenderFns } from "./IFCustomizeReport.vue?vue&type=template&id=5ebc75d0&scoped=true"
import script from "./IFCustomizeReport.vue?vue&type=script&lang=js"
export * from "./IFCustomizeReport.vue?vue&type=script&lang=js"
import style0 from "./IFCustomizeReport.vue?vue&type=style&index=0&id=5ebc75d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebc75d0",
  null
  
)

export default component.exports